
import { Component, Vue } from 'vue-property-decorator'
import { NavigationGuardNext, Route } from 'vue-router'
import ScriptLoader from '@/utils/ScriptLoader'
import TeaserAccountTile from '@/components/tile/TeaserAccountTile.vue'
import TeaserResetPassword from '@/componentsTenant/images/TeaserResetPassword.vue'
import { isAuthenticated } from '@/utils/KeycloakUtils'

@Component({
  components: {
    TeaserAccountTile,
    TeaserResetPassword
  },
  beforeRouteEnter(to: Route, from: Route, next: NavigationGuardNext) {
    Promise.all([
      ScriptLoader.preloadScript(window.ENV_CONFIG.WEB_COMPONENTS.ACCOUNT_MANAGEMENT).catch((_reason) =>
        Promise.resolve()
      )
    ])
      .then(() => next())
      .catch((_reason) => next())
  },
  beforeRouteLeave(to: Route, from: Route, next: NavigationGuardNext) {
    Promise.all([
      ScriptLoader.unloadScript(window.ENV_CONFIG.WEB_COMPONENTS.ACCOUNT_MANAGEMENT).catch((_reason) =>
        Promise.resolve()
      )
    ])
      .then(() => next())
      .catch((_reason) => next())
  }
})
export default class ResetPasswordPage extends Vue {
  private assetsBaseUrl: string = window.ENV_CONFIG.ASSETS_BASE_URL.CUSTOMER_PORTAL || ''

  private loggedIn = false

  public mounted(): void {
    this.loggedIn = isAuthenticated()
  }
}
